import { memo } from "react";

import { Heading } from "@components/Heading";
import { RichText } from "@components/RichText";
import { tw } from "classnames";

const styles = {
  overviewWrapper: tw("pb-4", "text-primary"),
  heading: tw("mb-4", "text-primary"),
};

const ProductOverviewBase = ({
  content,
  heading,
}: {
  content: string;
  heading: string;
}) => {
  return (
    <>
      <div className={styles.overviewWrapper}>
        <Heading as="h6" className={styles.heading}>
          {heading}
        </Heading>
        <RichText content={content} />
      </div>
    </>
  );
};

export const ProductOverview = memo(ProductOverviewBase);
